import { requestTimeout } from '../common/util'
import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'
import Stickyfill from 'stickyfilljs'

const bodyScrollLock = require('body-scroll-lock')
const disableBodyScroll = bodyScrollLock.disableBodyScroll
const enableBodyScroll = bodyScrollLock.enableBodyScroll

const header = 'site-header'
const searchOpenTrigger = 'js-site-search-trigger'
const searchCloseTrigger = 'js-site-search-close'
const searchForm = 'site-search__form'
const htmlSearchActive = 'js-search-active'

const nav = 'site-nav'
const htmlMenuActive = 'js-menu-active'
const navOpen = 'js-site-nav-open'
const navClose = 'js-site-nav-close'

const $header = document.querySelector('.site-header')
const $searchForm = document.querySelectorAll('.site-search__form')

const $nav = document.querySelector('.site-nav')
const $navOpen = document.querySelector('.js-site-nav-open')
const $navClose = document.querySelector('.js-site-nav-close')

const state = {
  headerHeight: null,
  stuck: false
}

const fn = {
  init: () => {
    state.headerHeight = $header.offsetHeight

    fn.handleScroll()
    fn.bindEvents()

    Stickyfill.add($header)
  },

  bindEvents: () => {
    window.addEventListener('scroll', throttle(fn.handleScroll, 50))
    window.addEventListener('resize', debounce(fn.handleResize, 250))

    $(document).on('click', `.${searchOpenTrigger}`, fn.handleOpenSearch)
    $(document).on('click', `.${searchCloseTrigger}`, fn.handleCloseSearch)

    // if ($searchForm) {
    //   on('submit', SELECTORS.asClass('searchForm'), fn.handleSearchSubmit)
    //   on('keyup', SELECTORS.asClass('searchForm'), fn.handleSearchKeyUp)
    // }

    document.addEventListener('click', fn.closeMenu)
    $navOpen.addEventListener('click', fn.openMenu)
    $navClose.addEventListener('click', fn.closeMenu)
    // window.addEventListener('resize', throttle(fn.handleResize, 250))
  },

  handleScroll: () => {
    state.stuck = window.pageYOffset > 1
    $header.classList.toggle('is-stuck', state.stuck)
  },

  handleResize: () => {
    state.headerHeight = $header.offsetHeight

    if (window.matchMedia('(min-width: 768px)').matches) {
      fn.closeMenu({ target: document.body })
    }
  },

  handleOpenSearch: () => {
    document.documentElement.classList.add(htmlSearchActive)

    requestTimeout(() => {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        document.querySelector('.site-search--desktop input:first-child').focus()
      } else {
        document.querySelector('.site-search--mobile input:first-child').focus()
      }
    }, 250)
  },

  handleCloseSearch: () => {
    document.documentElement.classList.remove(htmlSearchActive)
    $searchForm.forEach($el => $el.querySelector('input').value = null)
    $searchForm.forEach($el => $el.classList.remove('has-error'))
  },

  handleSearchSubmit: (e) => {
    const $input = e.target.querySelector('input')

    if ($input.value === '') {
      e.preventDefault()
      $input.closest(SELECTORS.asClass('searchForm')).classList.add('has-error')
      $input.focus()
    }
  },

  handleSearchKeyUp: () => {
    $searchForm.forEach($el => $el.classList.remove('has-error'))
  },

  openMenu: (e) => {
    e.stopPropagation()
    $nav.style.top = `${window.pageYOffset}px`
    document.documentElement.classList.add(htmlMenuActive)

    disableBodyScroll($nav)
  },

  closeMenu: ({ target }) => {
    if (!target.closest('.site-search-close') && (target.closest('.js-site-nav-close') || !target.closest('.site-nav'))) {
      document.documentElement.classList.remove(htmlMenuActive)

      requestTimeout(() => {
        $nav.style.top = null
      }, 300)

      enableBodyScroll($nav)
    }
  },
}

export default {
  can: () => document.contains($header),
  run: fn.init
}
